import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { useGmailAuth } from '../../hooks/useGmailAuth';

export default function ConnectGmailButton() {
  const [isConnecting, setIsConnecting] = useState(false);
  const { initiateAuth } = useGmailAuth();

  const handleConnect = async () => {
    setIsConnecting(true);
    try {
      await initiateAuth();
    } finally {
      setIsConnecting(false);
    }
  };

  return (
    <button
      onClick={handleConnect}
      disabled={isConnecting}
      className="btn btn-primary flex items-center gap-2"
    >
      <Plus className="w-4 h-4" />
      {isConnecting ? 'Connecting...' : 'Connect Gmail'}
    </button>
  );
}